import styled from 'styled-components';
import { colors, spacing } from 'syf-component-library/defaultTheme';
const Separator = styled.div `
  border-top: 1px solid ${colors.lightGrey};
  padding-top: ${spacing.xlarge}px;
`;
export default Separator;
